import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getHomeImages } from '../../../../api/home/queries/getHomeImages';
import { IHomeImage } from '../../../../interfaces/HomeImage.interfaces';

interface IUseGetHomeImagesQueryParams {
  searchParam: {
    category: 'CAROUSEL_MAIN' | 'CAROUSEL_SUB';
  };
}

export const useGetHomeImagesQuery = ({ searchParam }: IUseGetHomeImagesQueryParams) => {
  return useQuery<IHomeImage[], AxiosError>(['home_images', `category=${searchParam.category}`], () =>
    getHomeImages({
      searchParam,
    }),
  );
};
